import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
export default () => {
  const createPoll = post => app.modal.show(() => import(/* webpackChunkName: 'forum/components/CreatePollModal', webpackMode: 'lazy-once' */ './components/CreatePollModal'), {
    onsubmit: data => app.store.createRecord('polls').save(_objectSpread(_objectSpread({}, data), {}, {
      relationships: {
        post
      }
    }), {
      data: {
        include: 'options,myVotes,myVotes.option'
      }
    }).then(poll => {
      var _post$rawRelationship, _post$rawRelationship2;
      // @ts-ignore
      (_post$rawRelationship = post.rawRelationship('polls')) == null || (_post$rawRelationship2 = _post$rawRelationship.push) == null || _post$rawRelationship2.call(_post$rawRelationship, {
        type: 'polls',
        id: poll.id()
      });
      return poll;
    })
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    // @ts-ignore
    if (!post.isHidden() && post.canStartPoll()) {
      items.add('addPoll', m(Button, {
        icon: "fas fa-poll",
        onclick: createPoll.bind(this, post)
      }, app.translator.trans('fof-polls.forum.moderation.add')));
    }
  });
};